<template>
  <div class="container">
    <h2 class="mt-4">{{ $t('add_group') }}</h2>

    <!-- Success and Error Messages -->
    <div v-if="successMessage" class="alert alert-success alert-dismissible fade show fixed-alert" role="alert">
      {{ successMessage }}
      <button type="button" class="btn-close" @click="successMessage = ''"></button>
    </div>

    <div v-if="errorMessage" class="alert alert-danger alert-dismissible fade show fixed-alert" role="alert">
      {{ errorMessage }}
      <button type="button" class="btn-close" @click="errorMessage = ''"></button>
    </div>

    <form @submit.prevent="submitGroup">
      <div class="mb-3">
        <label for="groupName" class="form-label">{{ $t('group_name') }}</label>
        <input v-model="groupForm.name" type="text" class="form-control" id="groupName" required/>
      </div>

      <!-- Permissions -->
      <div class="mb-3">
        <label class="form-label">{{ $t('permissions') }}</label>
        <div class="row">
          <!-- Iterate over chunked permissions -->
          <div v-for="(chunk, index) in chunkedPermissions" :key="index" class="row">
            <div v-for="permission in chunk" :key="permission.id" class="col-md-3 mb-2">
              <div class="form-check">
                <input
                    class="form-check-input"
                    type="checkbox"
                    :value="permission.id"
                    v-model="groupForm.permission_ids"
                    :id="'permission-' + permission.id"
                >
                <label class="form-check-label" :for="'permission-' + permission.id">
                  {{ permission.name }}
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>

      <button type="submit" class="btn btn-primary">{{ $t('add_group') }}</button>
      <router-link to="/groups" class="btn btn-secondary">{{ $t('cancel') }}</router-link>
    </form>
  </div>
</template>


<script>
import axios from 'axios';

export default {
  name: 'GroupAdd',
  data() {
    return {
      groupForm: {
        name: '',
        permission_ids: []  // Store only permission IDs
      },
      permissions: [], // Stores all permissions
      chunkedPermissions: [], // Stores permissions divided into chunks of 4
      successMessage: '',
      errorMessage: ''
    };
  },
  mounted() {
    this.getPermissions();
  },
  methods: {
    async getPermissions() {
      try {
        const response = await axios.get('/api/v1/admin/permissions/');
        this.permissions = response.data.results;
        this.chunkedPermissions = this.chunkArray(this.permissions, 4); // Chunk permissions into groups of 4
      } catch (error) {
        this.errorMessage = 'Failed to fetch permissions';
        console.log(error);
      }
    },
    async submitGroup() {
      try {
        // Sending the group data with permission IDs
        await axios.post('/api/v1/admin/groups/', this.groupForm);
        this.successMessage = 'Group added successfully';
        this.errorMessage = '';

        // Show success message for 2 seconds, then redirect to group list
        setTimeout(() => {
          this.$router.push('/groups');
        }, 2000);

      } catch (error) {
        this.errorMessage = 'Failed to add group';
        this.successMessage = '';

        // Show error message for 2 seconds, then redirect to group list
        setTimeout(() => {
          this.$router.push('/groups');
        }, 2000);
      }
    },
    chunkArray(array, size) {
      const chunked = [];
      for (let i = 0; i < array.length; i += size) {
        chunked.push(array.slice(i, i + size));
      }
      return chunked;
    }
  }
};
</script>
